import i from "./td-longtail-vue-components226.js";
/* empty css                              */
import r from "./td-longtail-vue-components98.js";
var n = function() {
  var t = this, o = t._self._c;
  return t._self._setupProxy, o("div", { staticClass: "dropdown-container", class: { "dropdown-container--right": t.showRight, "dropdown-container--auto-width": t.autoWidth } }, [t.$slots.input ? o("div", { staticClass: "dropdown-container__input" }, [t._t("input")], 2) : t._e(), o("div", { staticClass: "dropdown-container__list", attrs: { id: `dropdown-list${t.uid}`, "aria-labelledby": `dropdown${t.uid}`, role: "listbox", "aria-multiselectable": t.isMultiSelect ? "true" : void 0 } }, [t._t("default")], 2), t.$slots.submit ? o("div", { staticClass: "dropdown-container__submit" }, [t._t("submit")], 2) : t._e()]);
}, s = [], a = /* @__PURE__ */ r(
  i,
  n,
  s,
  !1,
  null,
  "381d1c0c"
);
const c = a.exports;
export {
  c as default
};
